import { render, staticRenderFns } from "./CampaignCallToAction.vue?vue&type=template&id=4cfe2542&"
import script from "./CampaignCallToAction.vue?vue&type=script&lang=js&"
export * from "./CampaignCallToAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports